<div class="n-table-wrapper">
    <h2>{{refDataCollections[collection] || collection}}</h2>
    @if (loading()) {
    <div class="n-spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    } @else {

    <mat-form-field class="example-chip-list">
        <!-- <mat-label>{{refDataCollections[collection] || collection}}</mat-label> -->
        <mat-chip-grid #chipGrid aria-label="Enter item">
            @for (item of data(); track item.id) {
            <mat-chip-row [editable]="true" (edited)="edit(item, $event)" (removed)="remove(item)"
                [aria-description]="'press enter to edit ' + item.name"
                matTooltip="Last modified on {{item.lastModifiedOn | date: 'dd/MM/yyyy HH:mm'}} by {{item.lastModifiedBy}}">
                <button matChipEdit [attr.aria-label]="'edit ' + item.name" class="chip-icon-button">
                    <mat-icon>edit</mat-icon>
                </button>
                {{item.name}}
                <button matChipRemove [attr.aria-label]="'remove ' + item.name">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip-row>
            }
        </mat-chip-grid>
        <input placeholder="New item..." [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)" />
    </mat-form-field>
    }
</div>